var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { getPrograms } from "../../generator-utils";
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { PdfViewer } from "./pdf-viewer";
var getFormatClass = function (values) {
    var program = values.program, format = values.format;
    var selectedProgram = getPrograms().find(function (_a) {
        var value = _a.value;
        return value === program;
    });
    var selectedFormatGroup = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.formatGroups.find(function (_a) {
        var formats = _a.formats;
        return formats.find(function (_a) {
            var formatTypes = _a.formatTypes;
            return formatTypes.find(function (_a) {
                var value = _a.value;
                return value === format;
            });
        });
    });
    var selectedFormat = selectedFormatGroup === null || selectedFormatGroup === void 0 ? void 0 : selectedFormatGroup.formats.find(function (_a) {
        var formatTypes = _a.formatTypes;
        return formatTypes.find(function (_a) {
            var value = _a.value;
            return value === format;
        });
    });
    var selectedFormatType = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.formatTypes.find(function (_a) {
        var value = _a.value;
        return value === format;
    });
    var pdfPreviewClass = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.pdfPreviewClass;
    var formatType = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.value;
    var formatWidth = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.width;
    return { pdfPreviewClass: pdfPreviewClass };
};
export var PreviewPdf = function () {
    var values = useFormikContext().values;
    var _a = __read(useState(null), 2), token = _a[0], setToken = _a[1];
    var pdfPreviewClass = getFormatClass(values).pdfPreviewClass;
    var handleVerify = function (token) {
        setToken(token);
    };
    return (React.createElement("div", { className: "preview-pdf" },
        React.createElement("div", { className: pdfPreviewClass != undefined ? "preview-pdf__container " + pdfPreviewClass : "preview-pdf__container" },
            React.createElement("div", { className: pdfPreviewClass != undefined ? "preview-pdf__wrapper " + pdfPreviewClass : "preview-pdf__wrapper" }, token == null ? (React.createElement(GoogleReCaptcha, { onVerify: function (token) {
                    handleVerify(token);
                } })) : (React.createElement(PdfViewer, { setToken: setToken, token: token }))))));
};
